/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-10 22:30 VN — WEB-20261010-suzitee-atc-fast (v6.2)
   Đã làm (v5 -> v6, chỉ file này): bấm ADD TO CART trong popup mà ảnh đã upload nền -> KHÔNG render lại 1000px
   (~1-1.2s CPU) nữa. Tra theo VÂN TAY NỘI DUNG canvas (JSON mọi object: chữ/font/ảnh/vị trí/ẩn-hiện + trạng thái tải
   ảnh/font + options), đúng vân tay lúc job nền render (đã kiểm trước/sau render bằng nhau) -> trả URL có sẵn.
   Không khớp vân tay -> đường cũ v5 (render + so byte / upload ngay). Thêm: job nền chạy được khi popup preview đã mở ổn
   định >=700ms (trước: popup mở là bỏ job); khách gõ trước khi Customily sẵn sàng -> job chạy ngay khi cài xong.
   Byte JPEG có thể lệch vài byte giữa 2 lần render cùng nội dung (cache object fabric theo zoom); QC so PIXEL thay byte
   (xem tmp/suzitee-mirror/final/ATC-FAST.md). Tắt khẩn vẫn là ?szpu=0 / window.__szPreuploadOff=1. */
/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-11 VN — WEB-20261011-suzitee-preupload
   Đã làm: PRE-UPLOAD ảnh preview Customily (kiểu Wanderprints). Trước: bấm ADD TO CART mới render + upload
   preview/thumb (~9.5s trên Fast4G) rồi mới /cart/add. Sau: khi khách ngừng sửa ~800ms (hoặc bấm xem preview)
   script render + upload NỀN (đúng hàm Customily generateLocalPreview + engraverPreviewImage.upload).
   Khoá = sha256 BYTE ảnh preview+thumb (+ options). Lúc ATC Customily gọi window.engraver.generatePreviewImage(opts)
   -> wrapper render local đúng hàm Customily (~0.3-1.8s), băm byte rồi:
     - trùng byte bản đã upload xong -> trả URL có sẵn (bỏ upload ~5-9s)
     - trùng + đang upload            -> chỉ chờ phần còn lại
     - không trùng / upload nền lỗi   -> upload ngay ảnh vừa render (= thân hàm gốc)
     - mọi lỗi của wrapper            -> gọi đúng hàm gốc Customily (luồng cũ)
   => URL trên đơn luôn là ảnh có byte == ảnh Customily render lúc bấm. (Bản thử dùng vân tay rẻ thay byte đã bị hậu-kiểm
      bắt lệch 2 byte khi job render lúc popup đang mở -> bỏ, xem PREUPLOAD.md.)
   Không sửa file vendor, không đổi setting Customily. Tắt khẩn: ?szpu=0 hoặc window.__szPreuploadOff=1. */
(function () {
  'use strict';
  if (window.__szPU) return;
  var PU = window.__szPU = { log: [], cache: {}, n: 0, hits: 0, miss: 0 };
  try { if (/[?&]szpu=0\b/.test(location.search) || window.__szPreuploadOff) { PU.off = 1; return; } } catch (e) {}

  var MAX_UPLOADS = 8, IDLE_MS = 800, AWAIT_CAP_MS = 25000, MODAL_SETTLE_MS = 700;
  var t0 = Date.now();
  function L(m) { try { PU.log.push(((Date.now() - t0) / 1000).toFixed(2) + ' ' + m); if (PU.log.length > 80) PU.log.shift(); } catch (e) {} }

  function cs() { return window.customilyShopify || {}; }
  function shop() { try { return (window.Shopify && window.Shopify.shop) || ''; } catch (e) { return ''; } }
  // Dựng opts y như unified.js dựng lúc ATC (đọc customilyShopify.preview / skipThumbGeneration / uploadPreviewToShopify)
  function buildOpts() {
    var c = cs(), pv = c.preview || {};
    return { width: pv.imageSize || 1000, height: pv.imageSize || 1000, quality: pv.quality || 100,
      thumbnail: { enabled: !(c.skipThumbGeneration || false), width: pv.thumbSize, height: pv.thumbSize },
      base64: pv.uploadPreviewToShopify || false, shop: shop() };
  }
  function optsKey(o) { try { return JSON.stringify(o); } catch (e) { return String(Math.random()); } }

  function hex(buf) { var a = new Uint8Array(buf), s = ''; for (var i = 0; i < a.length; i++) s += (a[i] < 16 ? '0' : '') + a[i].toString(16); return s; }
  // Vân tay rẻ (chỉ để bỏ qua job trùng, KHÔNG dùng để quyết định tái sử dụng lúc ATC):
  // JSON object canvas + trạng thái tải ảnh/font. Không phụ thuộc kích thước hiển thị/popup.
  function material(eng, ok) {
    var cv = eng.canvas, j = '', ls = [];
    try { j = JSON.stringify(cv.toJSON(['uuid', 'hideGroup', 'visible', 'id'])); } catch (e) { j = 'x' + Math.random(); }
    try {
      (function walk(objs) {
        (objs || []).forEach(function (o) {
          if (!o) return;
          if (o._element) ls.push((o._element.complete ? 1 : 0) + ':' + (o._element.naturalWidth || o._element.width || 0));
          if (o.fontFamily && document.fonts && document.fonts.check) { try { ls.push(document.fonts.check('12px "' + o.fontFamily + '"') ? 'f1' : 'f0'); } catch (e) {} }
          if (o._objects) walk(o._objects);
          if (o.clipPath && o.clipPath._objects) walk(o.clipPath._objects);
        });
      })(cv.getObjects());
    } catch (e) { ls.push('x' + Math.random()); }
    return ok + '|' + j + '|' + ls.join(',');
  }
  function dims(eng) { try { var c = eng.canvas; return c.getWidth() + 'x' + c.getHeight() + '@' + c.viewportTransform.join(','); } catch (e) { return 'x'; } }
  var mOpenAt = 0; // v6: ms popup preview đã mở liên tục (-1 = đang đóng)
  function modalAge() { if (!modalOpen()) { mOpenAt = 0; return -1; } if (!mOpenAt) mOpenAt = Date.now(); return Date.now() - mOpenAt; }
  function modalOpen() { try { var m = document.querySelector('.customily-modal-preview-only'); return !!(m && m.offsetParent); } catch (e) { return false; } }
  function sha(buf) { return crypto.subtle.digest('SHA-256', buf).then(hex); }
  function fingerprint(eng, ok) { return sha(new TextEncoder().encode(material(eng, ok))); }
  // Khoá thật: sha256(opts + byte preview + byte thumb) của ảnh do chính Customily render.
  function blobKey(loc, ok) {
    return Promise.all([loc.preview.arrayBuffer(), loc.thumbnail ? loc.thumbnail.arrayBuffer() : Promise.resolve(new ArrayBuffer(0))])
      .then(function (bs) { return Promise.all([sha(bs[0]), sha(bs[1])]); })
      .then(function (h) { return sha(new TextEncoder().encode(ok + '|' + h[0] + '|' + h[1])); });
  }
  function idle(eng) { // canvas ở trạng thái "nghỉ": không zoom-vào-object, không đang chọn object
    try { return eng.initReady && !eng.CANVAS_ZOOM_IN_OBJECT && !(eng.canvas.getActiveObject && eng.canvas.getActiveObject()); } catch (e) { return false; }
  }

  var ENG = null, origGen = null, origLocal = null, timer = null, busy = false, again = false, uploads = 0, atcBusy = 0;

  var byFp = {}, byKey = {}, rendering = [];
  PU.cache = byKey; // debug/QC: khoá ảnh -> trạng thái upload
  function remember(map, k, v) { var ks = Object.keys(map); if (ks.length >= 4) delete map[ks[0]]; map[k] = v; }

  function job() {
    var eng = ENG; if (!eng || PU.off) return;
    if (busy) { again = true; return; }
    if (atcBusy) return;                        // v6: ATC đang chạy -> không render/upload chen (tranh CPU + mạng)
    if (uploads >= MAX_UPLOADS) return;
    // v6: popup preview đang mở -> đợi popup đứng yên MODAL_SETTLE_MS rồi mới render (không render giữa lúc popup đang mở ra)
    var ms = modalAge(); if (ms >= 0 && ms < MODAL_SETTLE_MS) { schedule(MODAL_SETTLE_MS - ms + 50); return; }
    if (!idle(eng)) { schedule(1500); return; } // đang zoom/chọn object: thử lại sau, không gọi gì lên canvas
    busy = true;
    var o = buildOpts(), ok = optsKey(o), fp1, d1, rd = {};
    rd.p = new Promise(function (res) { rd.res = res; });
    Promise.resolve(eng.waitFilesUpload && eng.waitFilesUpload()).catch(function () {})
      .then(function () { var a = modalAge(); if (!idle(eng) || (a >= 0 && a < MODAL_SETTLE_MS)) throw 'notidle'; d1 = dims(eng); return fingerprint(eng, ok); })
      .then(function (f) {
        fp1 = f;
        if (byFp[f] && byFp[f].st !== 'fail') { L('pre skip same fp ' + f.slice(0, 8)); throw 'same'; }
        rendering.push(rd);
        var ts = Date.now();
        return Promise.resolve(origLocal.call(eng, o)).then(function (loc) {
          if (!loc || !loc.preview) throw new Error('nolocal');
          return Promise.all([blobKey(loc, ok), fingerprint(eng, ok)]).then(function (r) {
            var key = r[0];
            if (r[1] !== fp1 || dims(eng) !== d1) { again = true; throw new Error('state changed during render'); }
            if (byKey[key] && byKey[key].st !== 'fail') { remember(byFp, fp1, byKey[key]); L('pre same image ' + key.slice(0, 8)); return; }
            uploads++;
            var ent = { ok: ok, st: 'up', ts: ts, key: key, fp: fp1 };
            L('pre upload start ' + key.slice(0, 8) + ' render ' + ((Date.now() - ts) / 1000).toFixed(2) + 's');
            ent.p = Promise.resolve(eng.engraverPreviewImage.upload({ shop: o.shop, preview: loc.preview, thumbnail: loc.thumbnail, format: o.extension || 'jpeg' }))
              .then(function (u) {
                if (!u || !u.previewUrl) throw new Error('no previewUrl');
                ent.st = 'done'; L('pre done ' + key.slice(0, 8) + ' ' + ((Date.now() - ts) / 1000).toFixed(1) + 's');
                return u;
              }, function (er) { ent.st = 'fail'; L('pre FAIL ' + (er && er.message)); throw er; });
            ent.p.catch(function () {});
            remember(byKey, key, ent); remember(byFp, fp1, ent);
            rd.res(); // render xong + đã đăng ký -> ATC đang chờ có thể tra
            return ent.p.catch(function () {});
          });
        });
      })
      .catch(function (e) { if (e === 'notidle') { L('pre skip busy canvas'); schedule(1500); } else if (e !== 'same') L('pre err ' + (e && e.message || e)); })
      .then(function () { rd.res(); rendering = rendering.filter(function (x) { return x !== rd; }); busy = false; if (again) { again = false; schedule(IDLE_MS); } });
  }
  function schedule(ms) { if (!ENG || PU.off) return; clearTimeout(timer); timer = setTimeout(job, ms == null ? IDLE_MS : ms); }

  function wrapped(opts) {
    var eng = this && this.canvas ? this : ENG, self = this, args = arguments;
    if (PU.off || !eng) return origGen.apply(self, args);
    var ok = optsKey(opts), tc = Date.now(), loc = null;
    clearTimeout(timer); atcBusy = 1; setTimeout(function () { atcBusy = 0; }, AWAIT_CAP_MS + 5000); // khoá có hạn, phòng promise treo
    var reuse = function (ent, how) {
      L('atc HIT ' + ent.key.slice(0, 8) + ' ' + how + ' st=' + ent.st);
      var st0 = ent.st, cap = new Promise(function (_, rj) { setTimeout(function () { rj(new Error('cap')); }, AWAIT_CAP_MS); });
      return Promise.race([ent.p, cap]).then(function (u) {
        PU.hits++; PU.lastHit = { how: how, waited: (Date.now() - tc) / 1000, st0: st0, previewUrl: u.previewUrl };
        L('atc reuse after ' + ((Date.now() - tc) / 1000).toFixed(2) + 's');
        return Object.assign({}, u, loc ? { previewBase64: loc.previewBase64, thumbnailBase64: loc.thumbnailBase64 } : {});
      });
    };
    var byRender = function () { // đường chậm: render local y như Customily, khoá theo byte ảnh
      return Promise.resolve(origLocal.call(eng, opts)).then(function (l) {
        loc = l;
        if (!loc || !loc.preview) { PU.miss++; L('atc ORIGINAL (no local)'); return origGen.apply(self, args); }
        return blobKey(loc, ok).then(function (key) {
          var ent = byKey[key];
          var fresh = function (why) { // = thân hàm gốc generatePreviewImage: upload ảnh vừa render + base64
            PU.miss++; L('atc upload now (' + why + ')');
            return Promise.resolve(eng.engraverPreviewImage.upload({ shop: opts && opts.shop, preview: loc.preview, thumbnail: loc.thumbnail, format: (opts && opts.extension) || 'jpeg' }))
              .then(function (u) { return Object.assign({}, u, { previewBase64: loc.previewBase64, thumbnailBase64: loc.thumbnailBase64 }); });
          };
          if (!ent || ent.st === 'fail') return fresh(ent ? 'pre failed' : 'no match ' + key.slice(0, 8));
          return reuse(ent, 'bytes').catch(function (e) { return fresh('await fail ' + (e && e.message)); });
        });
      });
    };
    // v6 đường nhanh: vân tay nội dung canvas lúc bấm == vân tay job nền đã render+upload -> dùng lại URL, không render.
    // Chỉ khi opts.base64=false (shop này false; base64 cần ảnh render lúc bấm).
    var fast = function () {
      if (opts && opts.base64) return null;
      return fingerprint(eng, ok).then(function (f) {
        PU.lastAtc = { fp: f.slice(0, 8), fps: Object.keys(byFp).map(function (k) { return k.slice(0, 8) + ':' + byFp[k].st; }) };
        var ent = byFp[f];
        return ent && ent.key && ent.st !== 'fail' ? ent : null;
      });
    };
    var pend = rendering.map(function (x) { return x.p; });
    return Promise.resolve(fast()).then(function (ent) {
      if (ent || !pend.length) return ent;
      // job nền đang render dở -> chờ nó đăng ký (tối đa 4s) rồi tra lại
      return Promise.race([Promise.all(pend), new Promise(function (r) { setTimeout(r, 4000); })]).then(fast);
    }).then(function (ent) {
      if (ent) return reuse(ent, 'fp').then(function (u) { if (window.__szPUdebug) postVerify(eng, opts, ok, ent.key, u); return u; },
        function (e) { L('atc fast fail ' + (e && e.message)); return byRender(); });
      return byRender();
    }).catch(function (e) { PU.miss++; L('atc ORIGINAL (err ' + (e && e.message) + ')'); return origGen.apply(self, args); })
      .then(function (u) { atcBusy = 0; return u; }, function (e) { atcBusy = 0; throw e; });
  }
  // CHỈ khi QC (window.__szPUdebug, khách thật không chạy): sau khi trả URL theo vân tay, render lại + so byte VÀ so pixel
  // giữa ảnh đã dùng (tải từ CDN) với ảnh render lại -> chứng minh đúng nội dung.
  function postVerify(eng, opts, ok, key, u) {
    setTimeout(function () {
      var loc2;
      Promise.resolve(origLocal.call(eng, opts)).then(function (l) { loc2 = l; return blobKey(l, ok); })
        .then(function (k2) {
          return fetch(u.previewUrl, { cache: 'no-store' }).then(function (r) { return r.blob(); }).then(function (b) {
            return Promise.all([createImageBitmap(b), createImageBitmap(loc2.preview)]);
          }).then(function (im) {
            var W = Math.min(im[0].width, im[1].width), H = Math.min(im[0].height, im[1].height), d = [];
            [0, 1].forEach(function (i) { var c = document.createElement('canvas'); c.width = W; c.height = H; var x = c.getContext('2d'); x.drawImage(im[i], 0, 0, W, H); d.push(x.getImageData(0, 0, W, H).data); });
            var sum = 0, mx = 0, over = 0, n = W * H;
            for (var j = 0; j < d[0].length; j += 4) { var m = Math.max(Math.abs(d[0][j] - d[1][j]), Math.abs(d[0][j + 1] - d[1][j + 1]), Math.abs(d[0][j + 2] - d[1][j + 2])); sum += m; if (m > mx) mx = m; if (m > 32) over++; }
            PU.verify = { bytes: k2 === key, used: key.slice(0, 8), rerender: k2.slice(0, 8), dims: [im[0].width, im[0].height, im[1].width, im[1].height], meanAbs: +(sum / n).toFixed(3), maxAbs: mx, pctOver32: +(100 * over / n).toFixed(4) };
            L('verify bytes=' + (k2 === key) + ' meanAbs=' + PU.verify.meanAbs + ' pct>32=' + PU.verify.pctOver32);
          });
        })
        .catch(function (e) { PU.verify = { err: String(e && e.message) }; });
    }, 3500);
  }

  function install() {
    var eng = window.engraver;
    if (!eng || eng === ENG || eng.__szPU || typeof eng.generatePreviewImage !== 'function' || typeof eng.generateLocalPreview !== 'function' || !eng.engraverPreviewImage || !eng.canvas || !(window.crypto && crypto.subtle)) return false;
    // engraver mới (Customily dựng lại) -> bỏ cache cũ, cài lại wrapper cho instance mới
    if (ENG) { byFp = {}; byKey = {}; PU.cache = byKey; rendering = []; uploads = 0; L('reinstall'); }
    ENG = eng; origGen = eng.generatePreviewImage; origLocal = eng.generateLocalPreview;
    eng.generatePreviewImage = wrapped; eng.__szPU = 1; L('installed');
    if (PU.touched) schedule(IDLE_MS); // v6: khách đã sửa ô trước khi Customily sẵn sàng -> pre-upload luôn
    // v6: canvas đổi mà form không phát sự kiện (vd crossword: bấm Create -> server sinh ô chữ ~4s rồi mới vẽ lên canvas)
    // -> nghe sự kiện object của fabric. Bỏ qua khi job/ATC đang render (render export của Customily cũng chạm canvas).
    try {
      if (eng.canvas && typeof eng.canvas.on === 'function') ['object:added', 'object:removed', 'object:modified', 'text:changed'].forEach(function (n) {
        eng.canvas.on(n, function () { if (!busy && !atcBusy && (PU.touched || uploads)) schedule(IDLE_MS); });
      });
    } catch (e) {}
    return true;
  }
  // dò engraver 500ms (tối đa 2 phút); sau khi cài thì 3s/lần để bắt instance mới (rẻ: chỉ so tham chiếu)
  var tries = 0, iv = setInterval(function () { if (install() || ++tries > 240) { clearInterval(iv); if (ENG) setInterval(install, 3000); } }, 500);

  // Kích hoạt: mọi thay đổi ô tuỳ chọn Customily / bấm trong form -> chờ nghỉ 800ms rồi pre-upload.
  function onEv(e) {
    try {
      var t = e.target; if (!t || !t.closest) return;
      if (!t.closest('.customily_option, form[action*="/cart/add"], .customily-modal-container, .csh-product-customizer-modal, #customily-app')) return;
      if (e.type !== 'click') PU.touched = 1; // v6: khách đã sửa ô (job theo sự kiện canvas chỉ chạy khi đã có tương tác)
      if (!ENG) return;
      // bấm nút ADD TO CART / preview: popup mở, canvas đổi kích thước -> không kích job (render lúc chuyển cảnh lệch byte)
      if (t.closest('#customily-cart-btn, #customily-cart-btn-preview, [name="add"], [type="submit"], #preview-close')) return;
      schedule(IDLE_MS);
      // v6.2: bấm nút trong form (vd "Create Crossword": server sinh ô chữ 4-8s, có khi không phát sự kiện canvas nào)
      // -> kiểm lại vân tay sau 4/8/12s. Vân tay trùng bản đã upload thì job thoát ngay (chỉ băm JSON, không render).
      if (e.type === 'click' && t.closest('button, [role="button"]')) [4000, 8000, 12000].forEach(function (d) { setTimeout(function () { if (!atcBusy) job(); }, d); });
    } catch (er) {}
  }
  ['input', 'change', 'focusout', 'click'].forEach(function (n) { document.addEventListener(n, onEv, true); });
})();
